module.exports = "/_next/static/images/GpLogo-db6b262bc348c8ec5aa86fb2eb92e9ab.svg";